export default __webpack_public_path__ + "static/bg-section-3-6b96c82a07f2a37820207fa1c402e266.svg";